import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ListIcon from "@material-ui/icons/List";
import MapIcon from "@material-ui/icons/Map";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Box from "@material-ui/core/Box";
import IconLabelButton from "./MyButton";
import Grid from "@material-ui/core/Grid";
import Moment from "react-moment";
import MaxWidthDialog from "./TestDialog";
import SuKienChiTietDialog from "./SuKienChiTietDialog";
import Container from "@material-ui/core/Container";
import { sizing, maxHeight } from "@material-ui/system";
import { Height } from "@material-ui/icons";
import KeHoachTauTimKiemControl from "./controls/KeHoachTauTimKiemControl";
import KeHoachTauEditDialog from "./KeHoachTauEditDialog";

const server = require("../lib/server.js");
const myLib = require("../lib/MyLib.js");

const columns = [
  { field: "id", headerName: "STT", width: 70 },
  { field: "KeHoachID", headerName: "Mã số", width: 80 },
  { field: "TenTau", headerName: "Tên tàu", width: 230 },
  {
    field: "TrangThai",
    headerName: "Kế hoạch",
    width: 130,
    renderCell: (params) =>
      params.getValue("TrangThai") == 0 ? "Thường trực" : "Chốt chặn",
  },
  {
    field: "BatDau",
    headerName: "Bắt đầu",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy">{params.getValue("BatDau")}</Moment>
    ),
  },
  {
    field: "KetThuc",
    headerName: "Kết thúc",
    width: 130,
    renderCell: (params) =>
      params.getValue("KetThuc") ? (
        <Moment format="DD-MM-yyyy">{params.getValue("KetThuc")}</Moment>
      ) : null,
  },
  { field: "ViTri", headerName: "Vị trí", width: 200 },
  {
    field: "HoatDong",
    headerName: "Trạng thái",
    width: 130,
    valueGetter: (params) =>
      params.getValue("HoatDong") === true ? "Lần cuối" : "Lịch sử",
  },
  { field: "NguoiCN", headerName: "Người CN", width: 120 },
  {
    field: "NgayCN",
    headerName: "Ngày CN",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy HH:mm">{params.getValue("NgayCN")}</Moment>
    ),
  },
];

class KeHoachTauPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: { Page: 1, PageSize: 10 }, //dieu kien tim kiem hien thoi
      dataRows: [], //danh sach ban ghi
      totalRows: 0, //tong so ban ghi
      open_them_sukien: false, //hien thi form nhap moi su kien
      open_chitiet_sukien: false,
      open_edit_sukien: false, //hien thi form edit su kien
      Editting_KeHoachID: undefined,
      showConfirmXoa: false,
    };
  }

  popupComp = undefined;

  componentDidMount() {}
  //call khi user thay doi trang
  handlePageChange = (params) => {
    if (this.callbackSearch) {
      this.callbackSearch(params.page);
    }
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <Box display='flex'>
          <KeHoachTauTimKiemControl
            onSearched={(dieukien, data) => {
              var total = data.total;
              console.log("ket qua", dieukien);
              data.danhsach.map((item, index) => {
                item.id = index + 1 + (dieukien.Page - 1) * dieukien.PageSize;
              });
              var search = {};
              Object.assign(search, dieukien);
              this.setState({
                search: search,
                dataRows: data.danhsach,
                totalRows: data.total,
              });
            }}
            callback={(func) => (this.callbackSearch = func)}
          />
        </Box>
        <Box flexGrow={1}>
          <DataGrid
            rows={this.state.dataRows}
            columns={columns}
            id="KeHoachID"
            autoHeight
            rowHeight={32}
            className={classes.gridContainer}
            pagination
            pageSize={this.state.search.PageSize}
            rowCount={this.state.totalRows}
            paginationMode="server"
            sortingMode="server"
            menuContainerStyle={{ zIndex: 999 }}
            onPageChange={this.handlePageChange}
            onCellClick={(params) => {
              console.log(params);
              this.setState({ Editting_KeHoachID: params.data.KeHoachID });
            }}
          />
        </Box>
        <Box alignSelf="flex-start" display="flex">
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            disabled={!global.User.Quyen.R231}
            icon={<AddCircleIcon />}
            text={"Thêm mới"}
            onClick={() => {
              this.setState({ open_them_sukien: true });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            disabled={
              this.state.Editting_KeHoachID === undefined ||
              !global.User.Quyen.R231
            }
            icon={<EditIcon />}
            text={"Sửa"}
            onClick={() => {
              this.setState({ open_edit_sukien: true, showConfirmXoa: false });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            disabled={
              this.state.Editting_KeHoachID === undefined ||
              !global.User.Quyen.R231
            }
            icon={<DeleteIcon />}
            text={"Xóa"}
            onClick={() => {
              this.setState({ open_edit_sukien: true, showConfirmXoa: true });
            }}
          />
        </Box>
        {this.state.open_them_sukien ? (
          <KeHoachTauEditDialog
            visible={this.state.open_them_sukien}
            fullWidth={true}
            maxWidth={"sm"}
            EditMode="them"
            onClose={() => this.setState({ open_them_sukien: false })}
          />
        ) : null}
        {this.state.open_edit_sukien ? (
          <KeHoachTauEditDialog
            visible={this.state.open_edit_sukien}
            fullWidth={true}
            maxWidth={"sm"}
            KeHoachID={this.state.Editting_KeHoachID}
            EditMode={this.state.showConfirmXoa ? "xoa" : "edit"}
            onClose={() =>
              this.setState({
                open_edit_sukien: false,
                Editting_KeHoachID: undefined,
                showConfirmXoa: false,
              })
            }
          />
        ) : null}
        {this.state.open_chitiet_sukien ? (
          <SuKienChiTietDialog
            visible={this.state.open_chitiet_sukien}
            fullWidth={true}
            maxWidth={"sm"}
            onClose={() => this.setState({ open_chitiet_sukien: false })}
          />
        ) : null}
      </>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  gridContainer: {
    height: "100vh",
  },
});

export default withStyles(styles, { withTheme: true })(KeHoachTauPage);
